module.exports = __webpack_public_path__ + "static/media/portfolio7-3.bd9dd78c.png";